/**
 * The signed-in user's token as an Authorization header, or nothing.
 *
 * For endpoints open to signed-out visitors that still treat a signed-in
 * account differently — the screenshot reader's per-account limit
 * ([[BUGS #482]]): without the token every account was counted as a guest.
 * Never throws: a token that cannot be read means "signed out" here.
 */
export async function optionalAuthHeaders(): Promise<Record<string, string>> {
  try {
    // Lazily: importing Firebase initialises it, which a caller's module (and
    // its tests) must not pay for just by importing this helper.
    const { auth } = await import('../firebase');
    const user = auth.currentUser;
    if (!user) return {};
    const token = await user.getIdToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}
